import React from 'react';

const NoAccessToVirtualSessionPopover = ({ sessionAccessError }) => (
    <div>
        <div className="text padding-top-xs">
            {sessionAccessError}
        </div>
    </div>);

export default NoAccessToVirtualSessionPopover;
